import React from "react";
import Link from "helpers/link";
import clsx from "clsx/lite";

const BlogCategoriesNav = ({ categories, isSearchOpen }) => (
	<div className={clsx("flex gap-3.5", isSearchOpen ? "w-0" : "w-11/12",
		"lg:w-full items-center bg-white py-2 pointer-events-auto overflow-x-auto md:overflow-x-auto")}
	>
		{categories.length > 0 &&
			categories.map((category, i) => (
				<Link state={{ preserveScroll: true }}
					key={i} to={category.handle === "blogs" ? "/blogs" : `/blogs/${category.handle}`}
					className="pill-base !px-6"
					activeClassName="bg-[#F5F5F5]"
				>
					<span>{category.title}</span>
				</Link>
			))}
	</div>
);

export default BlogCategoriesNav;